import { SET_STATS, RESET_STATS } from "../types"

const initialState = {
  units: 0,
  systems: 0,
  totalCost: 0,
}

const statsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_STATS:
      return {
        ...state,
        ...action.payload, 
      };
    case RESET_STATS:
      return initialState
    default:
      return state;
  }
}

export default statsReducer
